import { Paper } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

const RightSidebarPaper: FC<PropsWithChildren> = ({ children }) => {
	return <Paper sx={{ padding: '27px', display: 'flex', flexDirection: 'column', gap: '15px', borderRadius: '1rem' }}>{children}</Paper>;
};
export default RightSidebarPaper;
